module.exports = __webpack_public_path__ + "static/media/gif_Tipeee_step_8.83034fab.gif";